import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

export enum CustomWallpaperToolsVariation {
  showCustomWallpaperTools = 'show-custom-wallpaper-tools',
  control = 'control',
}

/**
 * Part of the Publish pod's Custom Wallpapers experiment (https://www.notion.so/wetransfer/Spec-1-1-Custom-wallpaper-per-Transfer-3ca54f92cef04c319173a983060c49a4).
 * Determines which users see the TransferCustomizationDrawer in the transfer window when sending a transfer.
 */
export default class CustomWallpaperToolsExperiment {
  static key = 'exp-custom-wallpaper-tools';

  static isControl(): boolean {
    return this.currentVariant() === CustomWallpaperToolsVariation.control;
  }

  static isShowCustomWallpaperTools(): boolean {
    return (
      this.currentVariant() ===
      CustomWallpaperToolsVariation.showCustomWallpaperTools
    );
  }

  static currentVariant(): CustomWallpaperToolsVariation {
    return getFullVariant(this.key, {
      value: CustomWallpaperToolsVariation.control,
    }).value as CustomWallpaperToolsVariation;
  }
}
